import { render, staticRenderFns } from "./IncomeNotesField.vue?vue&type=template&id=2326360c&"
import script from "./IncomeNotesField.vue?vue&type=script&lang=js&"
export * from "./IncomeNotesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2326360c')) {
      api.createRecord('2326360c', component.options)
    } else {
      api.reload('2326360c', component.options)
    }
    module.hot.accept("./IncomeNotesField.vue?vue&type=template&id=2326360c&", function () {
      api.rerender('2326360c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/incomes/fields/IncomeNotesField.vue"
export default component.exports